import { Checkbox } from "../Checkbox";
import "../../styles/choice-card.css";
import type { ICheckboxCardProps } from "./types";

export const CheckboxCard = ({
  disabled,
  checkboxPosition = "start",
  className,
  ...checkboxProps
}: ICheckboxCardProps) => {
  const rootClassName = [
    "nuco-choice-card",
    `nuco-choice-card--${checkboxPosition}`,
    disabled && "nuco-choice-card--disabled",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <Checkbox
      disabled={disabled}
      checkboxPosition={checkboxPosition}
      {...checkboxProps}
      className={rootClassName}
      isCard
      renderCheckbox={undefined}
    />
  );
};
